//@flow

import type { ProductType } from "../../types/product";

export async function addWishlistToCart(
  products: ProductType[]
): Promise<number> {
  const addItems = products.map(p => ({
    productCode: p.productCode,
    quantity: p.quantity,
    pack: "ONE"
  }));
  if (addItems.length > 0) {
    return new Promise((resolve, reject) => {
      window.CART.fn.addItems(
        {
          addItems
        },
        undefined,
        resolve,
        reject
      );
    });
  } else {
    return Promise.resolve(0);
  }
}
